import { Timezone } from "@/interfaces/timezone";

export const Timezones: Timezone[] = [
  {
    id: 400,
    country_id: null,
    country_code: null,
    zone: "Alaska Standard Time",
    code: null
  },
  {
    id: 399,
    country_id: null,
    country_code: null,
    zone: "Pacific Standard Time",
    code: null
  },
  {
    id: 396,
    country_id: null,
    country_code: null,
    zone: "Mountain Standard Time",
    code: null
  },
  {
    id: 389,
    country_id: null,
    country_code: null,
    zone: "Central Standard Time",
    code: null
  },
  {
    id: 379,
    country_id: null,
    country_code: null,
    zone: "Eastern Standard Time",
    code: null
  }
];
